export default __webpack_public_path__ + "static/media/insta12.80d46f7e.webp";